import { useAction } from '@src/redux/hooks/useAction';
import { useSelect } from '@src/redux/hooks/useSelect';
import { setReloadPopup } from './actions';

const reloadPopupSelector = (state) => {
  return state.reloadPopup;
};

export const useReloadPopup = {
  state: () => {
    return useSelect(reloadPopupSelector);
  },
  actions: () => {
    return {
      setReloadPopup: useAction(setReloadPopup),
    };
  },
};
